import { clearPrivateRuntimeCaches } from '~/lib/pwa/authCache.mjs';

export function useImpersonation() {
  const { fetch: fetchSession } = useUserSession();
  const router = useRouter();

  const impersonate = async (userId: string) => {
    const result = await useFetch('/api/users/impersonate/start', {
      method: 'POST',
      body: { userId }
    });

    if (result.error.value) {
      console.error('Erro no impersonate:', result.error.value);
      return result;
    }

    await clearPrivateRuntimeCaches();
    await fetchSession();

    window.location.href = router.currentRoute.value.fullPath;

    return result;
  };

  const stopImpersonation = async () => {
    const result = await useFetch('/api/users/impersonate/stop', {
      method: 'POST'
    });

    if (result.error.value) {
      console.error('Erro ao parar a personifica\u00e7\u00e3o:', result.error.value);
      return result;
    }

    await clearPrivateRuntimeCaches();
    await fetchSession();
    window.location.href = router.currentRoute.value.fullPath;

    return result;
  };

  return {
    impersonate,
    stopImpersonation
  };
}
